import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import HeroImage from "../assets/images/bizecho-homepage.png";
import DashboardBizEchoVideo from "../assets/videos/bizecho-what-we-do-intro.mp4";
import PostSalesFeedback from "../assets/videos/Post Sales_bizecho.mp4";
import PostEnquiryFeedback from "../assets/videos/Enquiry_WhatsApp Video.mp4";
import PostServiceFeedback from "../assets/videos/Post Service_Bizecho.mp4";

import Header from "../components/Header";
import { FooterPublic } from "./FooterPublic";

const montserrat = {
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800"],
};
export default function Home() {
  const navigate = useNavigate();
  return (
    <main
      className={`${montserrat.className} min-h-screen bg-gradient-to-b bg-gray-900 text-gray-100 antialiased`}
    >
      {/* HEADER */}
      <Header />
      {/* HERO */}
      <section className="max-w-7xl mx-auto px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-sm text-teal-300 font-semibold uppercase tracking-wider">
              A lightweight CRM for automobile companies
            </p>
            <h2 className="mt-4 text-4xl md:text-6xl font-extrabold leading-tight text-white">
              Focused on Customer Feedback{" "}
              <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
                & Lead Management
              </span>
            </h2>
            <p className="mt-6 text-lg text-gray-300 leading-relaxed max-w-xl">
              Turn feedback and leads into higher sales and happier customers —
              with WhatsApp automation, NPS insights, and conversion-first
              workflows.
            </p>

            <div className="mt-8 flex gap-4">
              <button
                onClick={() => navigate("/book-a-demo")}
                className="btn inline-flex items-center gap-3 px-6 py-3 font-semibold shadow-xl text-lg"
              >
                🚀 Book a Demo
              </button>
              <button
                onClick={() => navigate("/book-a-demo")}
                className="inline-flex items-center gap-2 border border-gray-700 px-5 py-3 rounded-lg text-base text-gray-200 hover:bg-gray-800 transition-all"
              >
                Start a Pilot
              </button>
            </div>
          </motion.div>

          {/* Dashboard Mockup */}
          <motion.div
            className="relative"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className="">
              <img
                alt="dealership dashboard"
                src={HeroImage}
                className="w-full h-62 object-contain opacity-85"
              />
              <div className="p-6">
                <div className="flex items-center justify-between">
                  {/* <div>
                    <div className="text-sm text-gray-300">
                      Overall Satisfaction
                    </div>
                    <div className="text-3xl font-bold mt-1 text-white">
                      NPS 62{" "}
                      <span className="text-sm text-gray-400 font-medium">
                        (This month)
                      </span>
                    </div>
                  </div> */}
                  {/* <div className="text-right">
                    <div className="text-xs text-gray-400">Response Ratio</div>
                    <div className="text-xl font-semibold text-teal-300">
                      68%
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
      {/* FEATURES */}
      <section id="features" className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-white">
            How{" "}
            <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">
              Bizecho
            </span>{" "}
            adds value
          </h3>
          <p className="text-gray-400 mt-3 max-w-2xl mx-auto text-lg">
            A digital assistant that automates feedback, filters leads, and
            protects your reputation — built specifically for Automobile
            companies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Digital CRE on WhatsApp",
              desc: "Automates follow-ups with higher response rates.",
              icon: "💬",
            },
            {
              title: "Lead Filtering",
              desc: "Identify genuine prospects and pass hot leads to sales.",
              icon: "⚡",
            },
            {
              title: "Asynchronous Responses",
              desc: "Capture replies anytime — no scheduling needed.",
              icon: "🕒",
            },
            {
              title: "Reduce Calling",
              desc: "Cut costs by shrinking repetitive calling.",
              icon: "📞",
            },
            {
              title: "Scale to Hundreds",
              desc: "Chatbot scales effortlessly for bulk enquiries.",
              icon: "📣",
            },
            {
              title: "Boost Conversions",
              desc: "NPS reveals friction points early.",
              icon: "🔍",
            },
          ].map((f, i) => (
            <motion.article
              key={i}
              whileHover={{ y: -6 }}
              className="p-6 rounded-xl bg-gray-900/50 border border-gray-800 shadow-md hover:border-teal-400 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-teal-400/20 to-cyan-400/20 flex items-center justify-center text-2xl">
                  {f.icon}
                </div>
                <div>
                  <h4 className="font-semibold text-lg text-white">
                    {f.title}
                  </h4>
                  <p className="text-sm text-gray-400 mt-2">{f.desc}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
      {/* PRODUCTS */}
      <section id="products" className="max-w-7xl mx-auto px-6 py-16">
        <div className="flex flex-col md:flex-row items-start justify-between mb-10">
          <h3 className="text-3xl font-bold text-white">Products</h3>
          <p className="text-gray-400 text-lg">
            Solve specific company needs — feedback, leads, service & more.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            {
              title: "AI Sales Agent",
              desc: "An intelligent conversational agent that guides car buyers and converts engagement into qualified leads.",
              href: "/ai-sales-agent",
              // highlight: true,
            },
            {
              title: "Post-Sales Feedback",
              desc: "Surveys via WhatsApp with referral prompts.",
            },
            {
              title: "Post-Enquiry Feedback",
              desc: "Capture intent after showroom visits.",
            },
            {
              title: "Post-Service Feedback",
              desc: "Identify service pain points instantly.",
            },
            {
              title: "Lead Management",
              desc: "Filter digital leads & pass them to sales.",
            },
          ].map((p, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.05 }}
              className={`p-6 rounded-2xl border transition-all ${
                p.highlight
                  ? "bg-gradient-to-br from-teal-500/10 to-cyan-500/10 border-teal-400"
                  : "bg-gray-900/50 border-gray-800 hover:border-teal-400"
              }`}
              onClick={() => navigate(p.href)}
            >
              <h4 className="mt-3 font-semibold text-lg text-white">
                {p.title}
              </h4>
              <p className="text-sm text-gray-400 mt-2">{p.desc}</p>
              {/* <div className="mt-4">
                <a
                  className="inline-flex items-center gap-2 text-sm font-medium text-cyan-300 hover:underline"
                  href="#"
                >
                  Learn more →
                </a>
              </div> */}
            </motion.div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pt-12">
          <div className="rounded-xl overflow-hidden border border-gray-800 shadow-lg pb-10 ">
            <h4 className="mt-3 text-center font-semibold text-lg text-white">
              Post-Sales Feedback
            </h4>
            <video className="h-full w-full rounded-lg" controls>
              <source src={PostSalesFeedback} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>{" "}
          <div className="rounded-xl overflow-hidden border border-gray-800 shadow-lg pb-10 ">
            <h4 className="mt-3 text-center font-semibold text-lg text-white">
              Post-Enquiry Feedback
            </h4>
            <video className="h-full w-full rounded-lg" controls>
              <source src={PostEnquiryFeedback} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>{" "}
          <div className="rounded-xl overflow-hidden border border-gray-800 shadow-lg pb-10 ">
            <h4 className="mt-3 text-center font-semibold text-lg text-white">
              Post-Service Feedback
            </h4>
            <video className="h-full w-full rounded-lg" controls>
              <source src={PostServiceFeedback} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>
      {/* DASHBOARD */}
      <section id="dashboard" className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-3xl font-bold text-white">
              Dashboard & Reports
            </h3>
            <p className="text-gray-300 mt-4 text-lg">
              Actionable insights: satisfaction scores, model-wise & rep-wise
              NPS, recurring issue trends, and CSV exports.
            </p>

            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-400">
              <li>✅ Overall & Monthly Scores</li>
              <li>✅ Model & Sales Rep-wise NPS</li>
              <li>✅ Categorized Issues</li>
              <li>✅ Response Ratios & Language Preferences</li>
            </ul>

            <div className="mt-8 flex gap-4">
              <button
                onClick={() => navigate("/book-a-demo")}
                className="px-5 py-3 rounded-lg bg-gradient-to-r from-teal-400 to-cyan-400 text-gray-900 font-semibold shadow-lg hover:brightness-110"
              >
                Request a Demo
              </button>
              <button
                onClick={() => navigate("/book-a-demo")}
                className="px-5 py-3 rounded-lg border border-gray-700 text-gray-200 hover:bg-gray-800"
              >
                Start a Pilot
              </button>
            </div>
          </div>

          <div>
            <div className="rounded-xl overflow-hidden border border-gray-800 shadow-lg">
              <video className="h-full w-full rounded-lg" controls>
                <source src={DashboardBizEchoVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </section>
      {/* FAQ */}
      <section id="faq" className="max-w-7xl mx-auto px-6 py-16">
        <h3 className="text-3xl font-bold text-white">FAQ</h3>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 text-sm">
          {[
            {
              q: "Will this replace my tele-calling team?",
              a: "Bizecho automates repetitive outreach & feedback capture, freeing your CREs to focus on high-value conversations.",
            },
            {
              q: "How do you protect customer data?",
              a: "We sign NDAs and follow enterprise-grade security (TLS, firewalls, access controls).",
            },
            {
              q: "Can I run a pilot?",
              a: "Yes — we offer a pilot for one showroom to validate ROI and response rates.",
            },
            {
              q: "Can I customize the WhatsApp chatbot templates?",
              a: "Absolutely — templates are fully customizable to your needs.",
            },
          ].map((faq, i) => (
            <details
              key={i}
              className="p-5 rounded-lg bg-gray-900/50 border border-gray-800 hover:border-teal-400 transition-all"
            >
              <summary className="font-semibold cursor-pointer text-white">
                {faq.q}
              </summary>
              <p className="mt-2 text-gray-400">{faq.a}</p>
            </details>
          ))}
        </div>
      </section>
      {/* Contact us  */}
      <FooterPublic />
    </main>
  );
}
